
    <div class="flex-row">
      <kpd-action
        icon="import"
        [title]="'Import' | translate"
        [disable]="loading"
        (action)="showImport = true"
        *ngIf="!showImport"
      >
      </kpd-action>
      <span *ngIf="showImport"
        ><input
          #filePicker
          class="hidden"
          type="file"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          (change)="onImport($event)"
          id="filePicker"
      /></span>
      <kpd-action
        icon="cancel"
        [title]="'Cancel' | translate"
        [disable]="loading"
        (action)="showImport = false"
        *ngIf="showImport"
      >
      </kpd-action>
    </div>
  